import {authHeader, handleResponsePublic as handleResponse} from '../_helpers';

export const casesService = {
  register,
  getAll,
  getById,
  getByCategoryYear,
  getByYear,
  getYears,
  getByYearCategory,
  update,
  delete: _delete,
  import: _import,
};

function getAll(api_params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases${api_params}`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/${id}`, requestOptions).then(handleResponse);
}

function getByCategoryYear(category, year) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/${category}/${year}`, requestOptions).then(handleResponse);
}

function register(appeal) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(appeal)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases`, requestOptions).then(handleResponse);
}

function update(appeal) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-store',
    body: JSON.stringify(appeal)
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/${appeal.id}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/${id}`, requestOptions).then(handleResponse);
}

function getByYear(year) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/sections/${year}`, requestOptions).then(handleResponse);
}

function getYears() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/years`, requestOptions).then(handleResponse);
}

function getByYearCategory(year, category_slug) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases/topics/${year}/${category_slug}`, requestOptions).then(handleResponse);
}

function _import(category_to_import, year_to_import) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-store'
  };

  return fetch(`${process.env.REACT_APP_API_URL}/cases_import_uk/${category_to_import}/${year_to_import}`, requestOptions).then(handleResponse);
}